import { assignInput, BaseModel } from '../base.model';

export class FileDataModel extends BaseModel {
  AttachmentID: number;
  OrigFileName: string = '';
  Description: string = '';
  AddDate: Date;
  AddedBy: string = '';
  FileName: string = '';
  isDownloading: boolean = false;

  constructor(o: any = null) {
    super(o);
    // WI 35894: re-apply o after this class's field initializers (see assignInput in base.model.ts).
    assignInput(this, o);
  }
}
